import DatePickerLocale from 'rmc-date-picker/lib/locale/en_US';
export default {
    okText: 'Ok',
    dismissText: 'Avbryt',
    extra: 'vänligen välj',
    DatePickerLocale,
};
